import { EfektDekoracyjny, MaterialBudowlany } from './../ankieta';
import { Project } from './../project';
import { Component, OnInit } from '@angular/core';
import { ProjectService } from '../project.service';

@Component({
  selector: 'app-questionnaire3',
  templateUrl: './questionnaire3.component.html',
  styleUrls: ['./questionnaire3.component.sass']
})
export class Questionnaire3Component implements OnInit {
  next: string = "/questionnaire4";
  prev: string = "/questionnaire2";
  EfektDekoracyjny = EfektDekoracyjny;
  project: Project

  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.setPrevQuestion();
    this.setNextQuestion();
  }
  onQuestion3Click(answer: EfektDekoracyjny) {
    this.projectService.setAnkietaPytanie3(answer);
    this.projectService.selectKnaufPlaster(this.project.ankieta.getSelectedKnaufPlaster());
    this.setNextQuestion();
  }
  setPrevQuestion() {
    if (this.project.ankieta.pytanie1b == MaterialBudowlany.drewno) {
      this.prev = "/questionnaire1";
    } else {
      this.prev = "/questionnaire2";
    }
  }
  setNextQuestion() {
    if (this.project.ankieta.isQuestion4Required()) {
      this.next = "/questionnaire4";
    } else {
      this.next = "/questionnaire-summary";
    }
  }
}
